import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import requiredIf from 'react-required-if';
import {
  annotations as annotationActions,
  modal as modalActions
} from './../actions';
import FeedbackComponent from './../Components/FeedbackComponent';
import { auth } from './../helpers';
import { annotation as annotationSelectors } from './../selectors';

export const mapStateToProps = (state, ownProps) => {
  const annotationsById = annotationSelectors.getFeedbackScoresByBuildIds(state);
  const userVotesByBuildIDs = annotationSelectors.getUserVoteByBuildIDs(state);
  const usersVoteAnnotation = ownProps.annotatedItem &&
    userVotesByBuildIDs[ownProps.annotatedItem.id] || { id: 0, status: 'None' };
  const votingResults = ownProps.annotatedItem &&
    annotationsById[ownProps.annotatedItem.id] ||
      { upVotes: 0, downVotes: 0, voteTotal: 0 };

  // need jira tickets associated
  return {
    title: ownProps.title,
    isDisabled: !ownProps.annotatedItem || !auth.checkAuthenticated(),
    disabledText: ownProps.disabledText,
    buttonText: 'Add Feedback',
    upVoteCount: votingResults.upVotes,
    downVoteCount: votingResults.downVotes,
    voteTotal: votingResults.voteTotal,
    currentVote: usersVoteAnnotation
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onVoteClick: (vote, usersVoteAnnotation) => {
      const userName = localStorage.getItem('userName') || '';
      //check incoming vote against existing vote
      if (usersVoteAnnotation.status !== 'None') {
        dispatch(annotationActions.removeBuildComment(usersVoteAnnotation.id));
      }

      if (vote !== usersVoteAnnotation.status) {
        dispatch(annotationActions.addBuildComment(
          ownProps.annotatedItem,
          {
            user: userName,
            status: vote,
            'extra_info': null
          }
        ));
      }
    },
    onCommentClick: () =>
      dispatch(modalActions.showAddComment(true, ownProps.annotatedItem)),
    onShowCommentsClick: () =>
      dispatch(modalActions.showCommentHistory(true, ownProps.annotatedItem))
  };
};

const FeedbackContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FeedbackComponent);

FeedbackContainer.propTypes = {
  annotationType: PropTypes.string.isRequired,
  annotatedItem: PropTypes.shape({ id: PropTypes.number.isRequired }),
  disabledText: requiredIf(PropTypes.string,
    props => props.annotedItem),
  title: PropTypes.string.isRequired
};
export default FeedbackContainer;


// WEBPACK FOOTER //
// src/Containers/FeedbackContainer.jsx